import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setPageTitle } from "signoxe/actions";
import PingSummary from "signoxe/components/PingSummary";
import "./styles.scss";
import {
  getDeviceGroups,
  getDevices,
  getProfile,
} from "signoxe/selectors";
import { getCampaigns } from "signoxe/selectors/campaigns";
import {
  fetchPingDevices,
  exportPingDevicestoCSV,
} from "signoxe/actions/remote";

class PingReportView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      pingsearchTerm: "",
      notPingsearchTerm: "",
      pingDevices: [],
      notPingDevices: [],
      ping_interval: "day",
      not_ping_interval: "day",
      ping_period: "1",
      not_ping_period: "1",
      pingLoading:false,
      unpingLoading:false,
      pingNameSort:"ascending",
      unpingNameSort:"ascending",
    };
  }

  static propTypes = {
    // Data

    // Functions
    setPageTitle: PropTypes.func.isRequired,
    profile: PropTypes.array.isRequired,
  };

  handlePingDevicesExport = () => {
    const { ping_interval, ping_period } = this.state;

    const pingData = {
      type: "ping",
      interval: ping_interval,
      period: ping_period || 1,
    };

    exportPingDevicestoCSV(pingData);


  };

  handleNotPingDevicesExport = () => {
    console.log("testing")
    const { not_ping_interval, not_ping_period } = this.state;

    const pingData = {
      type: "not_ping",
      interval: not_ping_interval,
      period: not_ping_period || 1,
    };

    exportPingDevicestoCSV(pingData);


  };

  getPingDevices = (interval=null, peroid=null) => {
    const { ping_interval, ping_period } = this.state;

    const pingData = {
      type: "ping",
      interval: interval || ping_interval,
      period: peroid || ping_period || 1,
    };
    this.setState({pingLoading: true})

    fetchPingDevices(pingData)
      .then((devices) => {
        this.setState({ pingDevices: devices });
      })
      .catch((err) => {
        console.log("Error fetching ping:", err);
        alert(err);
      });
     this.setState({pingLoading: false})

  };

  getNotPingDevices = (interval=null, peroid=null) => {
    const { not_ping_interval, not_ping_period } = this.state;

    const notPingData = {
      type: "not_ping",
      interval: interval || not_ping_interval,
      period: peroid || not_ping_period || 1,
    };
    this.setState({unpingLoading: true})

    fetchPingDevices(notPingData)
      .then((devices) => {
        this.setState({ notPingDevices: devices });
      })

      .catch((err) => {
        console.log("Error fetching ping:", err);
        // alert(err);
      });
      this.setState({unpingLoading: false})
  };

  getPingData = () => {
    this.getPingDevices();
    this.getNotPingDevices();
  };

  componentDidMount() {
    this.props.setPageTitle("Ping Dashboard"); // Set the page title
    console.log("got here");

    this.getPingData();

    const intervalMinutes = 5;
    this.pingDataInterval = setInterval(this.getPingData, intervalMinutes * 60 * 1000);

  }

  componentWillUnmount() {
    // Clear the interval when the component is unmounted to prevent memory leaks
    clearInterval(this.pingDataInterval);
  }


  handlePingInterval = (e) => {
    this.setState({ ping_interval: e.target.value });
    this.getPingDevices(e.target.value, null )

  };

  handleNotPingInterval = (e) => {
    this.setState({ not_ping_interval: e.target.value });
    this.getNotPingDevices(e.target.value, null )
  };

  handlePingPeroid = (e) => {
    if (e.target.value > 0 ){
      this.setState({ ping_period: e.target.value });
      this.getPingDevices(null, e.target.value);
    }
  };

  handleNotPingPeroid = (e) => {
    if (e.target.value > 0 ){
      this.setState({ not_ping_period: e.target.value });
      this.getNotPingDevices(null, e.target.value)
    }
  };

  handlePingSearch = (e) => {
    this.setState({ pingsearchTerm: e.target.value });
  };

  handleNotPingSearch = (e) => {
    this.setState({ notPingsearchTerm: e.target.value });
    
  };

  handlePingSortMethod = () => {
    const {pingNameSort} = this.state
    if (pingNameSort === "ascending" ) {
      this.setState({ pingNameSort : "descending" }))
    }
    if (pingNameSort === "descending") {
      this.setState({ pingNameSort : "ascending" })
    }
  }

  handleUnPingSortMethod = () => {
    const {unpingNameSort} = this.state
    if (unpingNameSort === "ascending" ) {
      this.setState({ unpingNameSort : "descending" }))
    }
    if (unpingNameSort === "descending") {
      this.setState({ unpingNameSort : "ascending" })
    }
  }
  render() {
    const {
      isVisible,
      pingsearchTerm,
      pingDevices,
      notPingDevices,
      notPingsearchTerm,
      ping_interval,
      not_ping_interval,
      ping_period,
      not_ping_period,
      pingLoading,
      unpingLoading,
      pingNameSort,
      unpingNameSort,
    } = this.state;
    const { profile } = this.props;
    const allowed_pages = profile && profile.allowed_pages;
    const isAllowed = true
      // profile && allowed_pages && profile.allowed_pages.report_page;
    console.log("pingDevices", pingDevices, ping_interval);

    return (
      <>
        {isAllowed === false ? (
          <div className="flex flex-jc-c ai-i-c" style={{ marginTop: "40%" }}>
            {" "}
            You don't have permission to view this page.
          </div>
        ) : (
          <div className={`PingReportPage ${isVisible && "fade"}`}>
            <div className="PingReportPage__column">
              <PingSummary
                title="that have pinged the last"
                data={pingDevices}
                interval={ping_interval}
                period={ping_period}
                searchTerm={pingsearchTerm}
                loading={pingLoading}
                handleOrder={this.handlePingSortMethod}
                sortName={pingNameSort}
                handleSearch={this.handlePingSearch}
                handleSelect={this.handlePingInterval}
                fetchResuults={this.getPingDevices}
                handleChangePeroid={this.handlePingPeroid}
                exportToCSV={this.handlePingDevicesExport}
                type="ping"
              />
            </div>
            <div className="PingReportPage__column">
              <PingSummary
                title="that have not pinged the last"
                data={notPingDevices}
                interval={not_ping_interval}
                period={not_ping_period}
                loading={unpingLoading}
                handleOrder={this.handleUnPingSortMethod}
                sortName={unpingNameSort}
                handleSelect={this.handleNotPingInterval}
                handleSearch={this.handleNotPingSearch}
                searchTerm={notPingsearchTerm}
                fetchResuults={this.getNotPingDevices}
                exportToCSV={this.handleNotPingDevicesExport}
                handleChangePeroid={this.handleNotPingPeroid}
                type="not_ping"
              />
            </div>
            <div className="big_wrap">
              <div className="canvas-wrap">
                <canvas id="canvas" width="300" height="300"></canvas>
                <span id="procent"></span>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setPageTitle,
  };
};

export default connect(
  (state) => ({
    isFetching: state.assets.isFetching,
    groups: getDeviceGroups(state),
    campaigns: getCampaigns(state),
    devices: getDevices(state),
    profile: getProfile(state),
  }),
  mapDispatchToProps
)(PingReportView);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PingReportView/index.js